<template>
    <div class="input-group mm-inputdate">
        <div class="input-group-prepend">
            <a href="#" @click.prevent="emitEvent('click')" class="input-group-text"><i class="ms-Icon ms-Icon--Calendar"></i></a>
        </div>
        <masked-input
            type="text"
            name="phone"
            :class="['form-control', { masked:  activeMask}]"
            v-model="inputValue"
            v-on:keyup="emitEvent('select')"
            :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
            :guide="true"
            :showMask="true"
            placeholderChar="_">
        </masked-input>
        
    </div>
</template>

<script>
    import MaskedInput from 'vue-text-mask'
    export default {
        name: 'Datepicker',
        components: {
            MaskedInput
        },
        props: ['value'],
        data() {
            return {
                inputValue: ''
            }
        },
        created: function() {
            if (this.value != '' && this.value != '01/01/1753') this.inputValue = this.value
        },
        methods: {
            emitEvent(event) {
                this.$emit(event, this.inputValue);
            }
        },
        computed: {
            activeMask: function () {
                return !(/\d/.test(this.inputValue));
            }
        },
        watch: {
            value: function(v) {
                
                this.inputValue = v;
            }
        }
    }
</script>

<style>
.mm-inputdate .input-group-prepend {
    max-height: 35px;
}
input.masked {
    color: #ccc;
}
</style>